$(function () {
	if ($(window).width() <= 1279) {
		$('.js-principles-item').click(function () {
			$(this).toggleClass('principles__item-heading_active').next().slideToggle();
		});
	}
})